<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="밀폐공간 현황"
      :tableData="[
        { id: 'no', title: '연번', type: 'no', width: '80px' },
        { id: 'input1', title: '팀명', type: 'text', placeholder: '청사관리' },
        { id: 'input2', title: '밀폐공간 장소', type: 'text', placeholder: '청사 옥상' },
        { id: 'input3', title: '공정명(개소)', type: 'text', placeholder: '저수조(2개소)' },
        { id: 'input4', title: '작업내용', type: 'text', placeholder: '내부세척' },
        { id: 'input5', title: '작업기준(작업시간)', type: 'text', placeholder: '1회/년(5월 작업)' },
        { id: 'input6', title: '작업방법', type: 'text', placeholder: '내부작업' },
        { id: 'input7', title: '작업형태', type: 'text', placeholder: '외주' },
        { id: 'input8', title: '밀폐공간 작업프로그램 수립여부', type: 'select', selectData: ['수립', '미수립'], placeholder: '수립'},
        { id: 'input9', title: '담당자', type: 'text', placeholder: '홍길동' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.tableList"
      class="mt-4"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" class="mt-28px"/>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import TableInspect from "@/components/TableInspect";
import TableInspectPerformanceEvaluation from "@/components/TableInspectPerformanceEvaluation.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField,
    CompanySelector,
    PhotoUploadGridModule,
    TableInspectPerformanceEvaluation,
    TableInspect,
    DateSelector,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    'form.tableList': {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.tableLength = value.length;
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        tableList: [],
        tableLength: 0,
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
